module.exports = __webpack_public_path__ + "static/media/5-d2_old.42011866.jpg";